import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BookOpen, MapPin, Crown, Sparkle, PawPrint, Path } from "@phosphor-icons/react";
import api from "../api";

const ICON = { expedition: MapPin, world: Path, rank: Crown, trait: PawPrint, achievement: Sparkle };

export default function Journal() {
  const [entries, setEntries] = useState(null);
  useEffect(() => { api.get("/journal").then((r) => setEntries(r.data.entries)).catch(() => setEntries([])); }, []);
  if (!entries) return <div className="py-20 text-center text-ff-muted">Turning the pages...</div>;

  return (
    <div data-testid="journal-page">
      <div className="mb-1 flex items-center gap-2">
        <BookOpen size={26} weight="duotone" className="text-ff-gold" />
        <h1 className="font-display text-4xl font-bold tracking-tight">Expedition Journal</h1>
      </div>
      <p className="mb-6 font-display text-lg italic text-ff-muted">A captain's illustrated record of the frontier.</p>

      {entries.length === 0 ? (
        <div className="ff-panel rounded-md p-10 text-center text-ff-muted">Your journal awaits its first entry.</div>
      ) : (
        <div className="relative ml-3 border-l-2 border-ff-brass/30 pl-6">
          {entries.map((e, i) => {
            const Icon = ICON[e.type] || MapPin;
            return (
              <motion.div key={i} initial={{ opacity: 0, x: 12 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.02 }}
                className="relative mb-5" data-testid={`journal-entry-${i}`}>
                <span className="absolute -left-[34px] flex h-6 w-6 items-center justify-center rounded-full border border-ff-brass/40 bg-ff-bg2">
                  <Icon size={13} weight="duotone" className="text-ff-gold" />
                </span>
                <div className="ff-parchment-card rounded-md p-4">
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-lg font-semibold text-[#1F1A12]">{e.title}</h3>
                    {e.outcome && <span className="rounded-sm bg-[#8a6d1f]/15 px-2 py-0.5 text-[10px] font-medium text-[#6b5323]">{e.outcome}</span>}
                  </div>
                  {e.note && <p className="mt-1 text-sm text-[#4a4030]">{e.note}</p>}
                  {e.when && <div className="mt-1 font-mono-ff text-[10px] text-[#8a7a55]">{new Date(e.when).toLocaleString()}</div>}
                </div>
              </motion.div>
            );
          })}
        </div>
      )}
    </div>
  );
}
